/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { StatusBadgeTone } from '@/shared/ui/components/basic/StatusBadge';
import StatusBadge from '@/shared/ui/components/basic/StatusBadge';

type RiskBand = 'Excelente' | 'Bom' | 'Moderado' | 'Atencao' | 'Critico';

const BAND_TONE_MAP: Record<RiskBand, StatusBadgeTone> = {
  Excelente: 'success',
  Bom: 'info',
  Moderado: 'warning',
  Atencao: 'warning',
  Critico: 'error',
};

interface RiskScoreBadgeProps {
  band: string;
  score?: number;
  className?: string;
}

/**
 * Status badge showing a client's risk band and optional score.
 *
 * @param props - The risk band, optional score, and className.
 * @returns The rendered risk score badge.
 */
export function RiskScoreBadge({ band, score, className }: RiskScoreBadgeProps) {
  const tone = BAND_TONE_MAP[band as RiskBand] ?? 'neutral';
  const label = score !== undefined ? `${band} (${score})` : band;
  return (
    <StatusBadge tone={tone} className={className}>
      {label}
    </StatusBadge>
  );
}
